import React from 'react'
import { isEmpty } from 'lodash'
import { Field } from 'formik'

import { TextField } from '@/components/forms/formik'
import { FormField } from '@/components/forms/FormField'
import RichTextEditor from '@/components/richTextEditor/RichTextEditor'

import { PlaybookFormActions } from '../../components/PlaybookFormActions'

export const StickyNoteForm = ({
  handleSubmit,
  handleCancel,
  errors,
  readOnly,
  ...formikProps
}) => {
  const submitDisabled = readOnly || !isEmpty(errors)

  return (
    <form onSubmit={handleSubmit} className="playbook-detail__content field-stack">
      <Field
        required
        label="Name"
        name="name"
        placeholder="e.g. Reminder, 5 Key Behaviors, ..."
        component={TextField}
        disabled={readOnly}
      />
      <FormField label="Display" disabled={readOnly}>
        <Field name="display.html" component={RichTextEditor} disabled={readOnly} />
      </FormField>
      <PlaybookFormActions
        isDisabled={submitDisabled}
        handleCancel={handleCancel}
        dirty={formikProps.dirty}
      />
    </form>
  )
}
